export default {
  title: "Budget",
  description: "Gérez votre budget de mariage",
  totalBudget: "Budget total",
  totalSpent: "Total dépensé",
  remaining: "Restant",
  toPay: "À payer",
  exceeded: "Dépassé",
  noCategories: "Aucune catégorie configurée",
  percentage: "Pourcentage",
  category: "Catégorie",
  addExpense: "Ajouter une dépense",
  editExpense: "Modifier la dépense",
  deleteExpense: "Supprimer la dépense",
  expenseTitle: "Titre de la dépense",
  amount: "Montant",
  date: "Date",
  vendor: "Prestataire",
  notes: "Notes",
  paid: "Payé",
  pending: "En attente",
  // status: "Statut", // Removed to avoid conflict with status object

  noExpenses: {
    title: "Aucune dépense",
    description: "Commencez par ajouter votre première dépense"
  },
  monthlyExpenses: "Dépenses mensuelles",
  sharing: {
    recipientEmail: "Email du destinataire",
    emailPlaceholder: "exemple@email.com",
    recipientName: "Nom du destinataire",
    namePlaceholder: "Nom",
    message: "Message",
    messagePlaceholder: "Votre message...",
    send: "Envoyer",
    cancel: "Annuler",
    title: "Partager le budget"
  },
  addFirstExpense: "Ajoutez votre première dépense",
  budgetOverview: "Aperçu du budget",
  expenseDetails: "Détails de la dépense",
  save: "Enregistrer",
  cancel: "Annuler",
  delete: "Supprimer",
  edit: "Modifier",
  view: "Voir",
  confirmDelete: "Êtes-vous sûr de vouloir supprimer cette dépense ?",
  expenseAdded: "Dépense ajoutée avec succès",
  expenseUpdated: "Dépense mise à jour avec succès",
  expenseDeleted: "Dépense supprimée avec succès",
  budgetExceeded: "Budget dépassé",
  budgetWarning: "Attention budget",
  budgetOnTrack: "Budget respecté",
  setBudget: "Définir le budget",
  editBudget: "Modifier le budget",
  budgetAmount: "Montant du budget",
  budgetSet: "Budget défini avec succès",
  budgetUpdated: "Budget mis à jour avec succès",
  currency: "Devise",
  estimatedCost: "Coût estimé",
  actualCost: "Coût réel",
  difference: "Différence",
  overBudget: "Au-dessus du budget",
  underBudget: "En dessous du budget",
  onBudget: "Dans le budget",
  budgetAnalysis: "Analyse du budget",
  categoryBreakdown: "Répartition par catégorie",
  monthlySpending: "Dépenses mensuelles",
  upcomingExpenses: "Dépenses à venir",
  recentExpenses: "Dépenses récentes",
  budgetSummary: "Résumé du budget",
  totalAllocated: "Total alloué",
  totalUnallocated: "Total non alloué",
  allocationPercentage: "Pourcentage d'allocation",
  spendingTrend: "Tendance des dépenses",
  averageExpense: "Dépense moyenne",
  largestExpense: "Plus grande dépense",
  smallestExpense: "Plus petite dépense",
  expenseCount: "Nombre de dépenses",
  budgetUtilization: "Utilisation du budget",
  projectedTotal: "Total projeté",
  savingsGoal: "Objectif d'économie",
  emergencyFund: "Fonds d'urgence",
  contingencyPercentage: "Pourcentage de contingence",
  recommendedContingency: "Contingence recommandée",
  // export: "Exporter", // Removed to avoid conflict with export object
  import: "Importer",
  exportToCsv: "Exporter en CSV",
  exportToPdf: "Exporter en PDF",
  importFromCsv: "Importer depuis CSV",
  downloadTemplate: "Télécharger le modèle",
  budgetTemplate: "Modèle de budget",
  customCategory: "Catégorie personnalisée",
  addCategory: "Ajouter une catégorie",
  categoryName: "Nom de la catégorie",
  categoryBudget: "Budget de la catégorie",
  categoryAdded: "Catégorie ajoutée avec succès",
  categoryUpdated: "Catégorie mise à jour avec succès",
  categoryDeleted: "Catégorie supprimée avec succès",
  duplicateCategory: "La catégorie existe déjà",
  search: "Rechercher des dépenses",
  filter: "Filtrer",
  filterByCategory: "Filtrer par catégorie",
  filterByStatus: "Filtrer par statut",
  filterByDate: "Filtrer par date",
  sortBy: "Trier par",
  sortByDate: "Trier par date",
  sortByAmount: "Trier par montant",
  sortByCategory: "Trier par catégorie",
  ascending: "Croissant",
  descending: "Décroissant",
  clearFilters: "Effacer les filtres",
  noFilterResults: "Aucune dépense ne correspond à vos filtres",
  showAll: "Tout afficher",
  showPaid: "Afficher payé",
  showPending: "Afficher en attente",
  thisMonth: "Ce mois-ci",
  lastMonth: "Le mois dernier",
  thisYear: "Cette année",
  customRange: "Période personnalisée",
  from: "De",
  to: "À",
  apply: "Appliquer",
  reset: "Réinitialiser",
  expenseCreated: "Dépense créée avec succès",
  totalExpenses: "{{count}} dépenses",
  estimateBudget: "Estimer le budget",
  estimateBudgetShort: "Estimer",
  newExpense: "Nouvelle dépense",
  add: "Ajouter",
  overview: "Vue d'ensemble",
  distribution: "Distribution",
  expensesList: "Liste des dépenses",
  exportPdf: "Exporter PDF",
  budgetUsed: "Budget utilisé",
  loading: "Chargement...",
  total: "Total",
  confirmDeleteExpense: "Êtes-vous sûr de vouloir supprimer cette dépense ?",
  noExpensesText: "Aucune dépense",
  importExpenses: "Importer les dépenses",
  exportExpenses: "Exporter les dépenses",
  budgetDetails: "Détails du budget",
  budgetHistory: "Historique du budget",
  budgetAnalytics: "Analyses du budget",
  budgetSettings: "Paramètres du budget",
  spent: "Dépensé",

  categories: {
    venue: "Lieu",
    catering: "Traiteur",
    flowers: "Fleurs",
    photography: "Photographie",
    music: "Musique",
    attire: "Tenue",
    rings: "Alliances",
    transportation: "Transport",
    decoration: "Décoration",
    invitations: "Invitations",
    gifts: "Cadeaux",
    honeymoon: "Lune de miel",
    miscellaneous: "Divers",
    beauty: "Beauté",
    other: "Autre",
    videography: "Vidéographie",
    accommodation: "Hébergement",
    stationery: "Papeterie",
    general: "Général",
    "Lieu et Réception": "Lieu et Réception",
    "Animation et Photo": "Animation et Photo",
    "Tenues et Accessoires": "Tenues et Accessoires",
    title: "Catégories"
  },

  form: {
        title: "Titre",
        amount: "Montant",
    category: "Catégorie",
    date: "Date",
    vendor: "Prestataire",
    notes: "Notes",
    paid: "Payé",
    errors: {
      titleRequired: "Le titre est requis",
      amountRequired: "Le montant est requis",
      categoryRequired: "La catégorie est requise",
      amountPositive: "Le montant doit être positif"
    },
    description: "Description",
    dueDate: "Date d'échéance",
    status: "Statut",
    submit: "Enregistrer",
    cancel: "Annuler",
    name: "Nom"
  },
  
  filters: {
    all: "Tous",
    category: "Catégorie",
    status: "Statut",
    vendor: "Prestataire",
    categoryPlaceholder: "Sélectionner une catégorie",
    vendorPlaceholder: "Sélectionner un prestataire",
    budgetsearch: "Rechercher des dépenses",
    group: "Catégorie",
    groupPlaceholder: "Sélectionner une catégorie...",
    tableAssigned: "Table assignée",
    allCategories: "Toutes les catégories",
    allStatuses: "Tous les statuts",
    startDate: "Date de début",
    endDate: "Date de fin",
    minAmount: "Montant min (€)",
    maxAmount: "Montant max (€)",
    resetFilters: "Réinitialiser les filtres",
    search: "Rechercher une dépense",
    clear: "Effacer les filtres",
    apply: "Appliquer",
    previous: "Précédent",
    next: "Suivant",
  },

  status: {
    paid: "Payé",
    unpaid: "Non payé",
    pending: "En attente",
    cancelled: "Annulé"
  },

  table: {
    title: "Titre",
    amount: "Montant",
    category: "Catégorie",
    date: "Date",
    status: "Statut",
    description: "Description",
    actions: "Actions"
  },

  estimator: {
    title: "Estimateur de budget",
    guestCount: "Nombre d'invités",
    region: "Région",
    services: "Services",
    lieu: "Lieu",
    traiteur: "Traiteur",
    photographie: "Photographie",
    fleurs: "Fleurs",
    musique: "Musique",
    tenues: "Tenues",
    calculate: "Calculer",
    estimatedBudget: "Budget estimé",
    validateBudget: "Valider le budget",
    adjustAmount: "Ajuster le montant",
    modifyCriteria: "Modifier les critères",
    next: "Suivant",
    previous: "Précédent",
    ileDeFrance: "Île-de-France",
    paca: "PACA",
    london: "Londres",
    otherUK: "Autre (Royaume-Uni)",
    madrid: "Madrid",
    barcelona: "Barcelone",
    berlin: "Berlin",
    munich: "Munich",
    otherRegion: "Autre région",
    style: "Quel style de mariage souhaitez-vous ?",
  },
  
  noExpensesFiltered: {
    title: "Aucune dépense ne correspond à vos filtres",
    description: "Essayez d'ajuster vos critères de recherche"
  },
  
  overrun: {
    title: "Budget dépassé",
    description: "Vous avez dépassé votre budget prévu"
  },
  
  success: {
    budgetUpdated: "Budget mis à jour avec succès"
  },
  
  errors: {
    addExpense: "Erreur lors de l'ajout de la dépense",
    deleteExpense: "Erreur lors de la suppression de la dépense",
    updateExpense: "Erreur lors de la mise à jour de la dépense",
    loadExpenses: "Erreur lors du chargement des dépenses",
    loadCategories: "Erreur lors du chargement des catégories",
    loadWedding: "Erreur lors du chargement des données du mariage",
    loadTemplate: "Erreur lors du chargement du modèle",
    updateBudget: "Erreur lors de la mise à jour du budget",
    noTemplateAvailable: "Aucun modèle disponible",
    noWeddingFound: "Aucun mariage trouvé",
    loadData: "Erreur lors du chargement des données",
    noUser: "Aucun utilisateur connecté",
    missingWeddingId: "ID du mariage manquant"
  },
  
  // Export section matching en.ts structure but keeping french translations
  // Note: en.ts has export object with table headers inside it
  
  pageExample: {
    title: "Gestion du Budget",
    subtitle: "Planifiez et suivez vos dépenses de mariage",
    connectedAs: "Connecté en tant que",
    noAccess: "Aucun accès",
    overviewDescription: "Aperçu général de vos dépenses et du budget restant",
    detailedExpenses: "Dépenses détaillées",
    detailedExpensesDescription: "Liste complète de toutes vos dépenses",
    share: "Partager",
    venues: {
      receptionVenue: "Lieu de réception",
      chateauVersailles: "Château de Versailles",
    },
    access: {
      readOnlyAccess: "Accès en lecture seule - Impossible de modifier",
      advancedConfig: "Configuration avancée",
      advancedConfigDescription: "Paramètres et configuration du budget",
      adminOnly: "Admin uniquement",
      adminZone: "Zone d'administration",
      adminZoneDescription: "Cette section contient des paramètres sensibles qui ne sont accessibles qu'aux administrateurs.",
      exportData: "Exporter les données",
      resetBudget: "Réinitialiser le budget",
      permissionsInfo: "Informations sur vos permissions",
      read: "Lecture",
      write: "Écriture",
      delete: "Suppression",
      share: "Partage",
    },
    description: "Ceci est un exemple de page budget avec des données fictives",
    accessLevel: "Niveau d'accès",
    permissions: "Permissions",
    venue: {
      title: "Lieu",
      name: "Château des Roses",
      capacity: "Capacité : 150 personnes",
      location: "Provence, France",
      contact: "Contact : +33 1 23 45 67 89"
    },
    admin: {
      title: "Administration",
      exportData: "Exporter les données",
      importData: "Importer les données",
      backupData: "Sauvegarder les données",
      resetData: "Réinitialiser les données"
    },
    status: {
      connected: "Connecté",
      synchronized: "Synchronisé",
      lastUpdate: "Dernière mise à jour : {{date}}"
    }
  },

  initialBudget: "Budget initial",
  used: "utilisé",
  paymentStatus: "État des Paiements",
  categoryProgress: "Progression par Catégorie",
  addExpenseLabel: "Ajouter une dépense",
  
  expenses: {
    title: "Dépenses",
    add: "Ajouter une dépense",
    edit: "Modifier la dépense",
    name: "Nom",
    amount: "Montant",
    category: "Catégorie",
    date: "Date",
    paid: "Payé",
    unpaid: "Non payé",
    notes: "Notes",
    vendor: "Prestataire",
    noExpenses: "Aucune dépense",
    total: "Total",
    filter: "Filtrer",
    search: "Rechercher",
    delete: "Supprimer",
    confirm: "Confirmer"
  },
  
  modal: {
    title: "Dépense",
    edit: "Modifier la dépense",
    delete: "Supprimer la dépense",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cette dépense ?"
  },

  summary: {
    total: "Total",
    spent: "Dépensé",
    remaining: "Restant",
    overBudget: "Dépassement",
    currency: "€"
  },

  analytics: {
    title: "Analyses budgétaires",
    insights: {
      title: "Insights et tendances",
      topCategory: {
        title: "Catégorie principale",
        description: "{{category}} représente {{percentage}}% de vos dépenses avec {{amount}}"
      },
      overBudget: {
        title: "Budget dépassé",
        description: "Vous avez dépassé votre budget de {{percentage}}% ({{amount}})"
      },
      nearBudget: {
        title: "Budget presque atteint",
        description: "Vous avez utilisé {{percentage}}% de votre budget. Il vous reste {{remaining}}"
      },
      increasingTrend: {
        title: "Dépenses en hausse",
        description: "Vos dépenses ont augmenté de {{amount}} ce mois ({{month}})"
      },
      decreasingTrend: {
        title: "Dépenses en baisse",
        description: "Vos dépenses ont diminué de {{amount}} ce mois ({{month}})"
      }
    },
    charts: {
      categoryDistribution: "Répartition par catégorie",
      monthlyTrend: "Tendance mensuelle",
      monthlySpending: "Dépenses mensuelles",
      cumulativeSpending: "Dépenses cumulées",
      averagePerCategory: "Moyenne par catégorie",
      averageSpending: "Moyenne des dépenses"
    },
    details: {
      title: "Statistiques détaillées",
      transactions: "transactions",
      average: "Moyenne"
    },
    overview: "Vue d'ensemble",
    byCategory: "Par catégorie",
    byMonth: "Par mois",
    trends: "Tendances"
  },
  
  messages: {
    createSuccess: "Dépense ajoutée avec succès",
    updateSuccess: "Dépense mise à jour avec succès",
    deleteSuccess: "Dépense supprimée avec succès",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer cette dépense ?",
    error: "Une erreur est survenue",
    budgetCreated: "Budget créé avec succès",
    budgetUpdated: "Budget mis à jour avec succès",
    budgetDeleted: "Budget supprimé avec succès",
    expenseAdded: "Dépense ajoutée avec succès",
    expenseUpdated: "Dépense mise à jour avec succès",
    expenseDeleted: "Dépense supprimée avec succès",
    categoryAdded: "Catégorie ajoutée avec succès",
    categoryUpdated: "Catégorie mise à jour avec succès",
    categoryDeleted: "Catégorie supprimée avec succès"
  },
};
